import { InjectionToken } from "@angular/core";
import { MenuFacade } from "../interfaces/menu-facade.interface";

export const MAIN_MENU_FACADE_TOKEN = new InjectionToken<MenuFacade>('MAIN_MENU_FACADE_TOKEN');
